import { TenantEntity } from '../TenantEntity'

export class AirlineProduct extends TenantEntity {
  /**
   * Constructor for AirlineProduct class
   *
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AirlineProduct'
  }

  get code() {
    return this._data.code
  }

  set code(code) {
    this._data.code = code || ''
  }

  get name() {
    return this._data.name
  }

  set name(name) {
    this._data.name = name || ''
  }

  get serviceProduct() {
    return this._data.serviceProduct
  }

  set serviceProduct(serviceProduct) {
    this._data.serviceProduct = serviceProduct || ''
  }

  get carrierId() {
    return this._data.carrierId || 0
  }

  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }

  get purchaseMethod() {
    return this._data.purchaseMethod
  }

  set purchaseMethod(purchaseMethod) {
    this._data.purchaseMethod = purchaseMethod || ''
  }

  get purchaseSource() {
    return this._data.purchaseSource || 0
  }

  set purchaseSource(purchaseSource) {
    this._data.purchaseSource = purchaseSource || 0
  }

  get portOfDeparture() {
    return this._data.portOfDeparture
  }

  set portOfDeparture(portOfDeparture) {
    this._data.portOfDeparture = portOfDeparture || ''
  }

  get airlineOperator() {
    return this._data.airlineOperator
  }

  set airlineOperator(airlineOperator) {
    this._data.airlineOperator = airlineOperator || ''
  }

  get remarks() {
    return this._data.remarks
  }

  set remarks(remarks) {
    this._data.remarks = remarks || ''
  }

  get active() {
    return this._data.active
  }

  set active(active) {
    this._data.active = active || false
  }

  get beginDate() {
    return this._data.beginDate
  }

  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }

  get endDate() {
    return this._data.endDate
  }

  set endDate(endDate) {
    this._data.endDate = endDate
  }
}
